import * as React from 'react';
import {useRoute} from 'react-router5';
import CourseBuilder from 'components/CourseBuilder';
import {Helmet} from 'react-helmet';

/**
 * The edit course page
 * @constructor
 */
export default function EditCourse(): React.ReactElement {
  const {route: {params}} = useRoute();

  return (
    <React.Fragment>
      <Helmet>
        <title>GrowPlace / Редактировать курс</title>
      </Helmet>
      <CourseBuilder courseId={params.id} />
    </React.Fragment>
  );
}
